/* eslint-disable jsx-a11y/anchor-is-valid */
import { Col, Row } from 'react-bootstrap'
import Dropdown from '../../../../sharedComponent/Dropdown/Dropdown'
import { SalesChannelType } from './SalesChannelUtils'

const SalesChannelInfo = ({
  data,
  updateData,
  hasError,
  formik,
  hasFieldError,
  method,
  validEmail,
  handleEmailValidation,
  isSolarProduct,
  isSparks,
  ...props
}: any) => {
  const handleSelectedItem = (e: any, name: any) => {
    if (e.value.length > 0) {
      formik.setFieldValue(name, e.label)
    } else {
      formik.setFieldValue(name, '')
    }
  }

  const filterValue = SalesChannelType.filter((item) =>
    isSparks ? item : item.id !== 'LEADGEN' && item.id !== 'OTM'
  )
  return (
    <div className='current' data-kt-stepper-element='content'>
      <div className='w-100'>
        {/* Modal Header Start */}
        <div className='fv-row mb-10'>
          <label className='d-flex align-items-center fs-4 fw-bold mb-4 lh-1'>
            <span>Sales Channel</span>
          </label>
        </div>
        {/* Modal Header End */}
        <div className='h-300px hover-scroll-overlay-y'>
          <Row
            className='d-flex align-items-end mt-5 no-gutters noPadding'
            style={{ marginBottom: '15px' }}
          >
            <Col sm={12} md={6} className='mr-0 ml-0 pb-5'>
              <label className='d-flex align-items-center mb-2'>
                <span className='fs-6 fw-semibold lh-23px required'>Sales Channel Name</span>
              </label>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid'
                name='salesChannelName'
                placeholder='Enter sales channel name'
                maxLength={51}
                {...formik.getFieldProps('salesChannelName')}
              />
              {formik.errors.salesChannelName && hasFieldError && (
                <div className='fv-plugins-message-container'>
                  <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                    {formik.errors.salesChannelName}
                  </div>
                </div>
              )}
            </Col>
            <Col sm={12} md={6} className='mr-0 ml-0 pb-5'>
              <label className='d-flex align-items-center mb-2'>
                <span className='fs-6 fw-semibold lh-23px required'>
                  Sales Channel Admin Email ID
                </span>
              </label>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid'
                name='salesChannelAdminEmail'
                placeholder='Enter email id'
                maxLength={51}
                {...formik.getFieldProps('salesChannelAdminEmail')}
                onBlur={(e) => handleEmailValidation(e.target.value)}
              />
              {formik.errors.salesChannelAdminEmail && hasFieldError && (
                <div className='fv-plugins-message-container'>
                  <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                    {formik.errors.salesChannelAdminEmail}
                  </div>
                </div>
              )}

              {!validEmail && !formik.errors.salesChannelAdminEmail && (
                <div className='fv-plugins-message-container'>
                  <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                    Email ID already exist
                  </div>
                </div>
              )}
            </Col>
          </Row>
          <Row
            className='d-flex align-items-end mt-5 no-gutters noPadding'
            style={{ marginBottom: '15px' }}
          >
            <Col sm={12} md={6} className='mr-0 ml-0 pb-5'>
              <label className='d-flex align-items-center mb-2'>
                <span className='fs-6 fw-semibold lh-23px required'>
                  Sales Channel Admin First Name
                </span>
              </label>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid'
                name='salesChannelAdminFirstName'
                placeholder='Enter admin name'
                maxLength={51}
                {...formik.getFieldProps('salesChannelAdminFirstName')}
              />
              {formik.errors.salesChannelAdminFirstName && hasFieldError && (
                <div className='fv-plugins-message-container'>
                  <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                    {formik.errors.salesChannelAdminFirstName}
                  </div>
                </div>
              )}
            </Col>
            <Col sm={12} md={6} className='mr-0 ml-0 pb-5'>
              <label className='d-flex align-items-center mb-2'>
                <span className='fs-6 fw-semibold lh-23px required'>
                  Sales Channel Admin Last Name
                </span>
              </label>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid'
                name='salesChannelAdminLastName'
                placeholder='Enter admin name'
                maxLength={51}
                {...formik.getFieldProps('salesChannelAdminLastName')}
              />
              {formik.errors.salesChannelAdminLastName && hasFieldError && (
                <div className='fv-plugins-message-container'>
                  <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                    {formik.errors.salesChannelAdminLastName}
                  </div>
                </div>
              )}
            </Col>
          </Row>
          <Row
            className='d-flex align-items-end mt-5 no-gutters noPadding'
            style={{ marginBottom: '15px' }}
          >
            <Col sm={12} md={6} className='mr-0 ml-0 pb-5'>
              <label className='d-flex align-items-center mb-2'>
                <span className='fs-6 fw-semibold lh-23px'>Sales Channel Type</span>
              </label>
              <Dropdown
                fieldName='salesChannelType'
                optionList={filterValue}
                handleSelectedItem={handleSelectedItem}
                formik={formik}
              />
            </Col>

            <Col sm={12} md={6} className='mr-0 ml-0 pb-5'>
              <label className='d-flex align-items-center mb-2'>
                <span className='fs-6 fw-semibold lh-23px'>Rep Id</span>
              </label>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid'
                name='repId'
                placeholder='Enter Rep Id'
                {...formik.getFieldProps('repId')}
              />
              {formik.errors.repId && (
                <div className='fv-plugins-message-container'>
                  <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                    {formik.errors.repId}
                  </div>
                </div>
              )}
            </Col>
          </Row>
        </div>
      </div>
    </div>
  )
}

export { SalesChannelInfo }
